export const COUNTRIES_URL = '/signin/v1/countries';
export const NEAR_COUNTRY_URL = '/signin/v1/countries/near';
